// This helper computes the set of
// user IDs that already belong to (are a member or manager of) some team OTHER than
// excludeTeamId, so pickers can disable them.
//
// The rule is one team per user PER ORGANIZATION (BI-1643), so callers must pass the
// CURRENT ORG's teams — which every caller does (useOrganizationTeams). Teams in other
// orgs are irrelevant and must not be included. Best-effort UX guard; the backend is
// authoritative.

export interface TeamMembershipShape {
  id?: string;
  member_ids?: string[];
  manager_id?: string;
}

export function usersAlreadyOnATeam(
  teams: TeamMembershipShape[] | undefined,
  excludeTeamId?: string,
): Set<string> {
  const assigned = new Set<string>();
  for (const team of teams ?? []) {
    if (excludeTeamId && team.id === excludeTeamId) continue;
    for (const id of team.member_ids ?? []) {
      if (id) assigned.add(id);
    }
    if (team.manager_id) assigned.add(team.manager_id);
  }
  return assigned;
}

export const ALREADY_ON_TEAM_HINT = 'Already in a team';
